import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JcErrorComponent } from './jc-error/jc-error.component';
import { WaitForJavaComponent } from './wait-for-java/wait-for-java.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/jc-error',
        pathMatch: 'full',
    },
    {
        path: 'wait-for-java',
        component: WaitForJavaComponent,
    },
    {
        path: 'jc-error',
        component: JcErrorComponent,
    },
    {
        path: 'cryptomat',
        loadChildren: () => import(`./cryptomat/cryptomat.module`).then(m => m.CryptomatModule),
    },
    {
        path: 'tr',
        loadChildren: () => import(`./ticket-redemption/ticket-redemption.module`).then(m => m.TicketRedemptionModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
